export default "__VITE_ASSET__jLuG_zxK__"